const Master = () => {
  return (
    <div
      id="master"
      className=" relative w-full h-full px-[calc((100%-var(--container))/2)] py-14 xl:py-28"
    >
      {/* <div id="title" className="text-point">
        <h3>COFFEE MASTER</h3>
      </div> */}
      <div className=" relative w-full h-full /mt-14 grid lg:grid-cols-3 gap-5 xl:gap-10">
        <div className=" relative w-full h-full">
          <img src="images/master.png" alt="master" id="573" height={832} />
        </div>
        <div
          // data-aos="fade-down"
          className=" relative w-full h-full lg:col-span-2 leading-relaxed grid items-center"
        >
          <div>
            <p className="continuous italic font-black">Coffee Master</p>
            <h4 className="text-point">SARAH CHOI</h4>
            <h5>
              Coffee Bean Roster,
              <br className="block lg:hidden" /> GB Explorer Sarah's coffee
            </h5>
            <ul className="leading-loose mt-8 lg:mt-14 xl:mt-20">
              <li>
                <small>35년간 로스팅과 블랜딩 기술을 연구 및 개발</small>
              </li>
              <li>
                <small>
                  싱글오리진 커피를 손쉽게 즐길 수 있도록 드립백 개발
                </small>
              </li>
              <li>
                <small>
                  생두와 허브를 저온 숙성 연구하여 커피에서 허브향을 블랜딩한
                  'Herb Coffee' 개발
                </small>
              </li>
              <li>
                <small>
                  화산지대에서 생산되는 원두를 럼주와 결합하여 'Holland coffee'
                  개발
                </small>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Master;
